/** @file Emits socket records (socket bone index, grip length, grip-2 bone) and validates mounts. */
import { checkDocMounts } from '@pose2d/format/doc/checkDocMounts';
import { entriesByName } from '@pose2d/format/doc/entriesByName';
import type { Doc, DocIndex, Pose2DError, Pose2DJson } from '@pose2d/format/types';
import { trig } from '@pose2d/math/trig';
import { requireCompiledIndex } from './requireCompiledIndex';
import { throwFirstError } from './throwFirstError';

type SocketJson = Pose2DJson['sockets'][number];

/** Throws MOUNT_INVALID when a mounted attachment is not on its socket bone or is a skinned mesh. */
export function compileSockets(doc: Doc, index: DocIndex, boneIndex: Map<string, number>): Pose2DJson['sockets'] {
  const problems: Pose2DError[] = [];
  checkDocMounts(doc, problems);
  throwFirstError(problems);
  return entriesByName(doc.sockets).map(([id, s]): SocketJson => ({
    name: s.name,
    bone: requireCompiledIndex(boneIndex, s.bone, 'bone', `sockets.${id}.bone`),
    length: trig.hypot(s.b[0] - s.a[0], s.b[1] - s.a[1]),
    ...(s.grip2Bone === undefined ? {} : { grip2Bone: requireCompiledIndex(boneIndex, s.grip2Bone, 'bone', `sockets.${id}.grip2Bone`) }),
  }));
}
